module.exports = __webpack_public_path__ + "img/img3.b3ceaff9.jpg";